import { render, staticRenderFns } from "./FormFiltros.vue?vue&type=template&id=715b130b"
import script from "./FormFiltros.vue?vue&type=script&lang=js"
export * from "./FormFiltros.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports